module.exports = __webpack_public_path__ + "static/img/thum1.7bfca4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/thum1.png
// module id = kMzb
// module chunks = 1